import React from "react";
import Image from "next/image";
import logo from "@/assets/images/logo-h.png";
import logobotom from "@/assets/images/logo-botom.png";
import styles from "@/styles/houseOfSenco.module.scss";
import { useAppDispatch } from "@/store";
import { useSelector } from "react-redux";
import { authActions, selectAuth } from "@/store/slices/auth";
import { selectCart } from "@/store/slices/cart";
import { selectWishlist } from "@/store/slices/wishlist";
import Link from "next/link";
import { Spinner } from "react-bootstrap";
import moment from "moment-timezone";

const DesktopHeader = () => {
  const dispatch = useAppDispatch();
  const authState = useSelector(selectAuth);
  const cartState = useSelector(selectCart);
  const wishlistState = useSelector(selectWishlist);
  moment.tz.setDefault("Asia/Kolkata");
  const currentDate = moment();
  const startDate = moment("2024-12-21", "YYYY-MM-DD").startOf("day");

  return (
    <header className={styles.desktop_header}>
      {/* <div className={styles.top_bar}> */}
      {/* <div className={styles.container}> */}
      {/* <p> */}
      {/* {" "} */}
      {/* {currentDate.isSameOrAfter(startDate) && ( */}
      <>
        {/* <strong>Love in luxury:</strong> Get Flat 30% OFF on Leather
                Bags & 10% OFF on LGD Jewellery! Explore now at{" "}
                <a target="_blank" href="https://sennes.in/" rel="noreferrer">
                  https://sennes.in/
                </a>{" "}
                *T&C Apply. */}
        {/* <strong>140+ </strong> New Styles Added to{" "}
            <strong>Fathers Day Sale - Up To 30% OFF*</strong> | Shop{" "}
            <a href="#">NOW</a> */}
        {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
      </>
      {/*  )}  */}
      {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
      {/* </p> */}
      {/* </div> */}
      {/* </div> */}
      <div className={styles.header_mid}>
        <div className={styles.container}>
          <div className="row  align-items-center">
            <div className="col-md-4">
              {/* <div className={styles.input}>
                  <input type="search" placeholder="Search" />
                </div> */}
            </div>
            <div className="col-md-4">
              <div className={styles.logo}>
                <Image src={logo} alt="logo" />
              </div>
            </div>
            <div className="col-md-4">
              <div className={styles.list_ul}>
                <ul>
                  {/* <li>
                    <Link href="/wishlist">
                      <a> WISH LIST ({wishlistState?.items?.length || 0}) </a>
                    </Link>
                  </li> */}
                  {/* <li>
                    <Link href="/cart">
                      <a> CART ({cartState?.items?.length || 0}) </a>
                    </Link>
                  </li> */}
                  {authState.user ? (
                    <li>
                      <Link
                        style={{ cursor: "pointer" }}
                        href={"/account/profile"}
                      >
                        <a>
                          <span>ACCOUNT</span>
                        </a>
                      </Link>
                    </li>
                  ) : (
                    <li>
                      {authState.isUserLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            dispatch(authActions.setIsModalOpen(true));
                          }}
                        >
                          <span>ACCOUNT</span>
                        </a>
                      )}
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.logo_bottom}>
          <Image src={logobotom} alt="logo Bottom" />
        </div>
      </div>
      <div className={styles.nav}>
        <div className={styles.container}>
          <nav>
            <ul>
              <li className={styles.navbar_dropdown}>
                <a href="#">JEWELLERY</a>
                <div className={styles.dropdown}>
                  <ul>
                    <li>
                      <a
                        href="https://www.sennes.in/collections/lab-grown-diamonds-jewellery"
                        target="_blank"
                      >
                        Lab Grown Diamonds{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://sencogoldanddiamonds.com/jewellery/category/aham-collection"
                        target="_blank"
                      >
                        Aham
                      </a>
                    </li>
                    <li>
                      <a href="https://everlite.com/" target="_blank">
                        Everlite
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <a
                  href="https://www.sennes.in/category/bags-and-accessories"
                  target="_blank"
                >
                  BAGS
                </a>
              </li>
              {/* <li>
                <a href="#"> STORES</a>
              </li> */}
              <li className={styles.navbar_dropdown}>
                <a href="#"> BRANDS</a>
                <div className={styles.dropdown}>
                  <ul>
                    <li>
                      <a href="https://www.sennes.in/" target="_blank">
                        Sennes
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://sencogoldanddiamonds.com/jewellery/category/aham-collection"
                        target="_blank"
                      >
                        Aham
                      </a>
                    </li>
                    <li>
                      <a href="https://everlite.com/" target="_blank">
                        Everlite
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default DesktopHeader;
